/* eslint-disable no-unused-vars */
import React, {createElement, useCallback, useContext, useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {useTranslation} from 'react-i18next';
import {ReactComponent as iconWarningLocation} from '../../assets/icons/map/map-geo-si-no-bg.svg';
import {MessageKeys} from '../../core/constants/map.enums';
import {RouteModel, StopModel} from '../../core/models';
import {diacriticSensitiveRegex} from '../../core/utils';
import {DataContext} from '../../services/data-v2/data.context';
import {MapContext} from '../../services/map-v2/map.context';
import {AmbIcon} from '../amb-icon/amb-icon.component';
import {List} from '../list/list.component';
import {ListItemInterface} from '../list/list.interface';
import SearchBar from '../search-bar/search-bar';
import TransportsComponent from '../transports/transports';
import './search.scss';
import {searchCall} from '../../services/api/api.utils';
import {SEARCH_HISTORY_SIZE} from '../../utils/utils';
import {SearchModel} from '../../core/models/search.model';

export const SearchComponent = () => {

    const {t} = useTranslation();

    const {db, pinSet, services} = useContext(DataContext);
    const {warningLocationVisibility} = useContext(MapContext);
    const [searching, setSearching] = useState(false);
    const [inputType] = useState('text');
    const [result, setResult] = useState<ListItemInterface<RouteModel | StopModel>[]>([]);
    const [addressList, setAddressList] = useState<any>([]);
    const [historyList, setHistoryList] = useState<any[]>([]);
    const [servicesGroups, setServiceGroups] = useState<any>([]);
    const [filteredPublicServices, setFilteredPublicServices] = useState<any>([]);
    const DataService = useContext(DataContext);

    const placeHolder = ('translation:web_search_bar_placeholder');
    useEffect(() => {
        const fetchPublicServices = async () => {
            if (db?.dataSources) {
                try {
                    const dbServiceGroups = await db.dataSources.serviceGroups.find({
                        selector: {
                            parent: {$in: [35]},
                        },
                    }) || [];
                    setServiceGroups(dbServiceGroups);
                } catch (error) {
                    console.error('Error fetching public services:', error);
                }
            }
        };
        fetchPublicServices();
    }, [db]);

    useEffect(() => {
        if (servicesGroups.length > 0) {
            const groupSlugs = servicesGroups.map((group: any) => group.slug);
            const filtered = services.filter((service) => groupSlugs.includes(service.groupSlug));
            setFilteredPublicServices(filtered);
        };
    }, [servicesGroups, services]);

    const updateHistoricSearch = () => {
        const ds = DataService.getAllRecentSearches();
        // .then((historicItems: any) => {
        //     if (historicItems) {
        //         const hList = historicItems.map((item: any) => {
        //             return {
        //                 id: item.item_id,
        //                 description: item.value,
        //                 historic: ' ',
        //             };
        //         });
        //         setHistoryList(hList);
        //     }
        // })
        // .catch((err:any) => {
        //     console.error(err);
        // });
    };

    // const saveSearch = (value: any) => {
    //     return DataService.getAllRecentSearches().then((searches: any) => {
    //         if (searches.length) {
    //             const existentElement = searches.find(((search: any) => search.item_id == value.id));
    //             if (existentElement) {
    //                 DataService.updateSearch(existentElement, 'datetime', new Date().getTime());
    //             } else {
    //                 if (searches.length >= SEARCH_HISTORY_SIZE) {
    //                     DataService.removeSearch(searches[14].datetime, 'datetime');
    //                 }
    //                 DataService.insertSearch({
    //                     item_id: value.id,
    //                     datetime: new Date().getTime(),
    //                     value: value.name,
    //                 });
    //             }
    //         } else {
    //             DataService.insertSearch({
    //                 item_id: value.id,
    //                 datetime: new Date().getTime(),
    //                 value: value.name,
    //             });
    //         }
    //     });
    // };

    const onChangeSearch = useCallback(async (value: any) => {

        if (db && pinSet && value.length && filteredPublicServices.length > 0) {
            setSearching(true);
            const slugsFiltered = filteredPublicServices.map((publicSlug: any) => publicSlug.slug);
            let stops: any = [];
            let routes: any = [];

            const $regex = new RegExp(`.*${diacriticSensitiveRegex(value)}.*`, 'i');

            if (!isNaN(value)) {
                const valueToString = value.toString();
                const regexValue = new RegExp(`${valueToString}`, 'i');
                stops = await db.dataSources?.stops.find({
                    selector: {
                        slug: {
                            $in: slugsFiltered,
                        },
                        $or: [
                            {stopName: {$regex: regexValue}},
                            {stopCode: {$regex: regexValue}},
                            {stopDesc: {$regex: regexValue}},
                        ],
                    },
                }) || [];

                routes = await db.dataSources?.routes.find({
                    selector: {
                        $or: [
                            {longName: {$regex}},
                            {shortName: {$regex}},
                        ],
                    },
                }) || [];
            } else {
                if (value.length > 2) {
                    stops = await db.dataSources?.stops.find({
                        selector: {
                            slug: {
                                $in: slugsFiltered,
                            },
                            $or: [
                                {stopName: {$regex}},
                                {stopDesc: {$regex}},
                                {stopCode: {$regex}},
                                {stopId: {$regex}},
                            ],
                        },
                    }) || [];

                    routes = await db.dataSources?.routes.find({
                        selector: {
                            $or: [
                                {longName: {$regex}},
                                {shortName: {$regex}},
                            ],
                        },
                    }) || [];
                }
            }

            if (!isNaN(value) || value.length > 2) {
                const address = await searchCall(value, 'cat');
                setAddressList(address);
            }

            setResult([
                ...stops.slice(0, 20).map((stop: any) => ({
                    id: stop.id,
                    title: <div style={{width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
                        <div>
                            {stop.stopName}
                        </div>
                        <div style={{whiteSpace: 'nowrap'}}>
                            {`Nº ${stop.stopCode || stop.stopId}`}
                        </div>
                    </div>,
                    href: `/stops/${stop.id}`,
                    icon: <AmbIcon
                        size="m"
                        shape="square"
                        backgroundColor={pinSet[stop.slug].color}
                        img={pinSet[stop.slug].icon}/>,
                    data: stop,
                })),
                ...routes.slice(0, 20).map((route: any) => ({
                    id: route.id,
                    title: route.longName,
                    href: `/lines/${route.id}`,
                    icon: <AmbIcon
                        text={route.shortName}
                        color={route.textColor}
                        backgroundColor={route.color}
                        shape={route.slug === 'busamb' ? 'round' : 'square'}
                        size="m"/>,
                    data: route,
                })),
            ]);
        } else {
            setSearching(false);
        }
    }, [db, pinSet, filteredPublicServices]);

    const onSearchFocus = (value: number) => {
        setSearching(value > 0);
        updateHistoricSearch();
    };

    const getWarningMessage = () => {
        const messageId = warningLocationVisibility;
        switch (messageId) {
        case MessageKeys.ENABLE:
            return t('translation:transport_root_location_snack');
        case MessageKeys.NO_SUPPORT:
            return t('translation:warnings_location_no-support');
        }
    };

    useEffect(() => {
        if (db) {
            db?.dataSources?.searches.find({
                selector: {},
                limit: 5,
                sort: [{createdAt: 'desc'}],
            })
                .then((data) => {
                    setHistoryList(data.map((item) => ({place_id: item.id, description: item.label})));
                });
        }
    }, [db]);

    return <div className={`search-container${isMobile ? ' mobile' : ''}`}>
        <SearchBar
            type={inputType}
            iconSearch={true}
            backIcon={false}
            value={{
                onChangeSearch,
                onFocus: onSearchFocus,
                placeHolder,
            }}/>
        <div className="desktop__search-container">

            {
                !searching && <>
                    <h3>{t('translation:transport_bottom_sheet_services_title')}</h3>
                    <TransportsComponent/>
                </>
            }
            {
                !searching && <>
                    {
                        (historyList.length > 0) ?
                            <><h3>{t('translation:transport_bottom_recent_search')}</h3><List
                                items={historyList}
                                isAddressList /></> : null
                    }
                </>
            }
            {
                searching &&
                <>
                    <List items={result}/>
                    <List items={addressList} isAddressList/>
                </>
            }
            {
                warningLocationVisibility > MessageKeys.NONE ?
                    <div className="warning-location">
                        {createElement(iconWarningLocation)}
                        <p>{getWarningMessage()}</p>
                    </div> : null
            }
        </div>
    </div>;
};
